module.exports = __webpack_public_path__ + "img/1557614074304471042.1c1d77ec.png";